/**
 * Vuex mutations for the "userauth" module.
 *
 * Synchronous state writers for the current user profile, auth status/error,
 * and the in-progress fields collected during the multi-step SMS
 * signup/onboarding flow (each `save*` mutation pulls its one field off a
 * `userData` payload object, e.g. `saveUserPhone` reads `userData.userPhone`).
 * Async work (API calls) lives in operations.js, which commits these
 * mutations with the results.
 */
export default {
  /** Set `state.user`, no-op if `state` or `payload` is falsy (guards against clearing/crashing on a bad call). */
  setUserData(state, payload) {
    if (!state || !payload) return;
    state.user = payload;
  },
  setUserDataError(state, payload) {
    state.error = payload;
  },
  setShowSmsCodeInput(state, value) {
    state.showSmsCodeInput = value;
  },
  saveUserPhone(state, userData) {
    state.userPhone = userData.userPhone;
  },
  saveUserName(state, userData) {
    state.userName = userData.userName;
  },
  saveUserFirstName(state, userData) {
    state.firstName = userData.firstName;
  },
  saveUserLastName(state, userData) {
    state.lastName = userData.lastName;
  },
  saveUserBirthDate(state, userData) {
    state.birthDate = userData.birthDate;
  },
  saveUserEmail(state, userData) {
    state.userEmail = userData.userEmail;
  },
  saveUserReferralCode(state, userData) {
    state.referralCode = userData.referralCode;
  },
  saveUserCounty(state, userData) {
    state.county = userData.county;
  },
  saveUserStreetAddress(state, userData) {
    state.streetAddress = userData.streetAddress;
  },
  saveUserStreetAddress2(state, userData) {
    state.streetAddress2 = userData.streetAddress2;
  },
  saveUserCity(state, userData) {
    state.city = userData.city;
  },
  saveUserAddressState(state, userData) {
    state.addressState = userData.addressState;
  },
  saveUserZipCode(state, userData) {
    state.zipCode = userData.zipCode;
  },
  setAuthErrorMessage(state, text) {
    state.authErrorNotification = text;
  },
  setAuthStatus(state, status) {
    state.authStatus = status;
  }
};
